/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Settings_Tab_Linked_ProjectsInputs */



/**
* | output |
* | --- |
* | "Linked projects" |
*
* @param {Spaces_Settings_Tab_Linked_ProjectsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_settings_tab_linked_projects = /** @type {((inputs?: Spaces_Settings_Tab_Linked_ProjectsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Settings_Tab_Linked_ProjectsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfte Projekte")
	return /** @type {LocalizedString} */ ("Linked projects")
});